<template >
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import { useTimeTracker } from '@/utils/global_timer'
export default {
    name: 'App',
    data(){
        return{
        }
    },
    created(){
        useTimeTracker()
    },
}

</script>

<style>
#app {
    height: 100%;
}
</style>
